/**
 *
 * Asynchronously loads the component for Integrations
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Integrations = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.Integrations,
);
